import { ReactElement } from 'react'
import PagamentoRepository from 'modules/pagamentos/infra/repositories/PagamentoRepository'
import HomePagamento from '../../pages/HomePagamento'
import ValidateUseNewHomeImpl from '../../domain/usecases/ValidateUseNewHome'

export const HomePagamentoFactory = (): ReactElement => {
  const pagamentoRepository = new PagamentoRepository()
  const verifyUseNewHome = new ValidateUseNewHomeImpl(pagamentoRepository)
  return <HomePagamento validUseNewHome={verifyUseNewHome} />
}

export default HomePagamentoFactory
